/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable react/require-default-props */
import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { PriorAuthorizationDomainContextProvider } from '../../context/ctxPriorAuthorizationDomain';
import { PriorAuthorizationDomain } from '../../interfaces/PriorAuthorizationDomain';
import DocumentUpload from '../DocumentUpload/documentUpload.component';
import Header from '../Header/header.component';
import './additionalclinicalupload.component.css';
import { appInsights } from '../../AppInsights';
import { useInterval } from '../../hooks/useInterval';
import ITokenService from '../../interfaces/ITokenService';
import TokenService from '../../services/Auth/TokenService';

export type additionalClinicalUploadModel = {
  partnerID: string,
  partnerName: string,
  userId: string,
  memberId: string,
  memberFirstName: string,
  memberLastName: string,
  memberDob: string,
  groupId: string,
  priorAuthId: string,
  upxServiceRequestId: string,
  authorizationStatus: string,
  levelOfUrgency: string,
};
type AppProps = {
  tokenService: ITokenService,
  delay?: number,
  runtime?: number
};
const AdditionalClinicalUpload = (props: AppProps) => {
  const location = useLocation();
  const domainObject: PriorAuthorizationDomain = location.state?.domainObject;
  const authorizationStatus: string = location.state?.authorizationStatus;
  useInterval(() => {
    console.log('Token Refresh Started...');
    props.tokenService.refreshToken()
      .then(() => {
        console.debug(`Token Refreshed: ${new Date().toLocaleString()}`);
        appInsights.trackTrace({ message: `Token Refreshed:${new Date().toLocaleString()}` });
      })
      .catch((error) => {
        appInsights.trackTrace({ message: 'Refresh Token error:' });
        appInsights.trackException({ exception: error });
      });
  }, props.delay || 900, props.runtime || 36000); // 900, 36000 // Poll Every 15min for 10hrs

  const memberDob : string = domainObject.priorAuthorizationDomainHeader.memberDOB
    ? new Date(domainObject.priorAuthorizationDomainHeader.memberDOB)
      .toLocaleDateString() : domainObject.priorAuthorizationDomainHeader.memberDOB;
  const additionalClinicalUploadDetailsObj: additionalClinicalUploadModel = {
    partnerID: domainObject.priorAuthorizationDomainHeader.partnerId,
    partnerName: domainObject.priorAuthorizationDomainHeader.partnerName,
    userId: domainObject.priorAuthorizationDomainHeader.userId,
    memberId: domainObject.priorAuthorizationDomainHeader.memberId,
    memberFirstName: domainObject.priorAuthorizationDomainHeader.memberFirstName,
    memberLastName: domainObject.priorAuthorizationDomainHeader.memberLastName,
    memberDob,
    groupId: domainObject.priorAuthorizationDomainHeader.memberGroupNumber,
    priorAuthId: domainObject.priorAuthorizationId,
    upxServiceRequestId: domainObject.priorAuthorizationId,
    authorizationStatus,
    levelOfUrgency: domainObject.priorAuthorizationDomianDetails[0].levelOfUrgency,
  };

  const [additionalClinicalUploadDetails,
    setAdditionalClinicalUploadDetails] = useState<additionalClinicalUploadModel>(additionalClinicalUploadDetailsObj);

  useEffect(() => {
    const additionalClinicalUpload:additionalClinicalUploadModel = {
      partnerID: domainObject.priorAuthorizationDomainHeader.partnerId,
      partnerName: domainObject.priorAuthorizationDomainHeader.partnerName,
      userId: domainObject.priorAuthorizationDomainHeader.userId,
      memberId: domainObject.priorAuthorizationDomainHeader.memberId,
      memberFirstName: domainObject.priorAuthorizationDomainHeader.memberFirstName,
      memberLastName: domainObject.priorAuthorizationDomainHeader.memberLastName,
      memberDob,
      groupId: domainObject.priorAuthorizationDomainHeader.memberGroupNumber,
      priorAuthId: domainObject.priorAuthorizationId,
      upxServiceRequestId: domainObject.priorAuthorizationId,
      authorizationStatus,
      levelOfUrgency: domainObject.priorAuthorizationDomianDetails[0].levelOfUrgency,
    };
    setAdditionalClinicalUploadDetails(additionalClinicalUpload);
  }, []);
  return (
    <PriorAuthorizationDomainContextProvider>
      <div data-testid="MemberClinicalUpload" className="Member-clinical-upload">
        <Header tokenService={props.tokenService} sessionType={TokenService.resumeSession} skipSavePriorAuthorization />
        <div className="row">
          <div className="col-md-8">
            <DocumentUpload
              index={1}
              items={{ serviceRequestId: additionalClinicalUploadDetails.upxServiceRequestId }}
              domainObj={domainObject}
              serviceRequestId={additionalClinicalUploadDetails?.upxServiceRequestId}
            />
          </div>
          <div className="col-md-4">
            <h3>
              <span>
                {`${additionalClinicalUploadDetails?.memberFirstName}
                 ${additionalClinicalUploadDetails?.memberLastName}` }
              </span>
            </h3>
            <span>
              DOB:
              {memberDob}
            </span>
            {' '}
            |
            <span>
              Member ID:
              {additionalClinicalUploadDetails.memberId}
            </span>
            <hr />
            <span>
              <b>
                #
                {additionalClinicalUploadDetails.upxServiceRequestId}
              </b>
            </span>
          </div>
        </div>
      </div>
    </PriorAuthorizationDomainContextProvider>
  );
};
export default AdditionalClinicalUpload;
